var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import moment from "moment";
import { Label2 } from "@irati/ui/src/Labels";
import { FormattedMessage, FormattedDate } from "@irati/utils/lang";
import id from "@irati/utils/id";
var StyledLabel = styled(Label2)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var DateHeader = /** @class */ (function (_super) {
    __extends(DateHeader, _super);
    function DateHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFormattedDate = function (date) {
            var startOfDate = date.startOf("day");
            var today = moment().clone().startOf("day");
            var yesterday = moment().clone().subtract(1, "days").startOf("day");
            if (startOfDate.isSame(today)) {
                return React.createElement(FormattedMessage, { id: "wallet.dateHeader.today" });
            }
            else if (startOfDate.isSame(yesterday)) {
                return React.createElement(FormattedMessage, { id: "wallet.dateHeader.yesterday" });
            }
            return React.createElement(FormattedDate, { value: startOfDate.toDate(), weekday: "long", year: "numeric", month: "long", day: "numeric" });
        };
        return _this;
    }
    DateHeader.prototype.render = function () {
        return (React.createElement(StyledLabel, { small: true, bold: true, uppercase: true, id: id("date-header", this.props) }, this.getFormattedDate(this.props.date)));
    };
    DateHeader.defaultProps = {
        id: null
    };
    return DateHeader;
}(PureComponent));
export default DateHeader;
var templateObject_1;
